import styled from 'styled-components';
import { Link } from 'react-router-dom';

export default styled(Link)`
  color: ${props => props.color || props.theme.primaryColor};
  font-weight: 600;
  text-decoration: none;
  font-size: ${props => props.fontSize || 'inherit'};
`;



// WEBPACK FOOTER //
// ./src/views/common/components/Link/index.jsx